export const isANumber = (str) => {
  return /^\d+$/.test(str) || str === "";
};
export const isValidPrice = (str) => {
  const strSplit = str.split(".");
  return (
    strSplit.length <= 2 &&
    (!strSplit[0] ||
      (isANumber(strSplit[0]) &&
        (!strSplit[1] || (isANumber(strSplit[1]) && strSplit[1].length <= 2))))
  );
};

export const validPhoneNumber =
  /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})||^\(?([0-9]{2})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
// /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

export const validPassword = /^(?=.*[a-zA-Z])(?=.*[0-9.,-]).{8,15}$/;

export const IsValidLength = (string, min, max) => {
  let valid = true;
  valid = valid && (!min || string.length >= min);
  valid = valid && (!max || string.length <= max);
  return valid;
};

/** Building number: digits plus Hebrew/Latin letters (e.g. 12א, 12A). */
export const BUILDING_NUMBER_PATTERN = /^[\d\u0590-\u05FFa-zA-Z]+$/;
export const BUILDING_NUMBER_MESSAGE =
  "מספר בניין יכול להכיל ספרות ואותיות בלבד";

export const DIGITS_ONLY_PATTERN = /^\d+$/;
export const DIGITS_ONLY_MESSAGE = "יש להזין ספרות בלבד";

export const SIGNED_INTEGER_PATTERN = /^-?\d+$/;
export const SIGNED_INTEGER_MESSAGE = "קומה חייבת להכיל ספרות בלבד";

export const stripToDigits = (value) => String(value ?? "").replace(/\D/g, "");

export const stripToSignedInteger = (value) => {
  let s = String(value ?? "").replace(/[^\d-]/g, "");
  const negative = s.startsWith("-");
  s = s.replace(/-/g, "");
  return negative ? `-${s}` : s;
};
